<template>
  <div class="main-body">
    <div class="header">护工列表</div>
    <div class="out">

      <div class="search2">

        <el-button size="mini" type="primary" plain @click.native="toggleModalAdd">添加</el-button>

        <div style="float:right;">

          <el-input placeholder="输入名称" v-model="name" clearable style="margin-right:10px;width:150px"></el-input>

          <el-button size="mini" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" v-loading="tableLoading"  :data="tableData" :height="th" border >

        <el-table-column prop="name" label="名称" width="100" fixed></el-table-column>
        <el-table-column prop="phone" label="登陆手机号" width="140" :formatter="getPhone"></el-table-column>
        <el-table-column prop="idCard" label="身份证号" width="200"></el-table-column>

        <el-table-column label="状态" width="100px">
          <template slot-scope="scope">
            <p v-if="scope.row.status ==1 ">正常</p>
            <p v-if="scope.row.status ==2 ">禁用</p>
          </template>
        </el-table-column>

        <el-table-column prop="countElderlyRel" label="服务对象数" ></el-table-column>

        <el-table-column prop="createTime" label="创建时间" width="180">
          <template slot-scope="scope">
            <p>{{scope.row.createTime | timefilters }}</p>
          </template>
        </el-table-column>


        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button type="text" size="mini" @click="handleElderlyEdit(scope.$index, scope.row)">服务对象</el-button>

            <el-button type="text" size="mini" @click="handlePassword(scope.$index, scope.row)">修改密码</el-button>

          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="pageSize"
              :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

    <el-dialog title="批量添加" @close='closeBatchDialog' :visible.sync="batchDialog"
               class="dialog" width='450px' center top='30vh' :close-on-click-modal='false'>
      <el-upload class="upload-demo" ref="upload"
                 :action="uploadUrl" :data='uploadData' :on-success="uploadSuccess"
                 :file-list="batchFileList" style="text-align: center;"
                 :auto-upload="false" :limit='1'>
        <el-button slot="trigger" type="primary">选取文件</el-button>
        <el-button  style="margin-left: 25px;" type="success" @click="getTemplate">下载模板</el-button>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchDialog=false">取 消</el-button>
        <el-button type="primary" @click="submitUpload">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog title="导入失败"  :visible.sync="batchDialogError" class="dialog" width='550px' center :close-on-click-modal='false'>
      <div style="max-height:350px;overflow-y: auto;">
        <div style="margin-bottom:10px" v-for="(item,i) in errorData" :key="i">
          <p v-show="/\d/.test(item)" style="line-height: 25px;">{{item}}</p>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchDialogError=false">确定</el-button>
      </div>
    </el-dialog>
    <div v-if="showModal" class="mask">
      <div class="lodingsIcon">
        <i class="el-icon-loading"></i><span>正在处理，请等待。。。</span>
      </div>
    </div>


    <ElderlyRel ref="myElderlyRel" v-show="showModalElderlyEdit" v-on:closeElderlyEdit="closeElderlyEdit" v-on:getList="getList"></ElderlyRel>



    <el-dialog title="密码修改" :visible.sync="pwdDialog" class="dialog" width='400px' center top='30vh'
               :close-on-click-modal='false'>
      <el-input v-model="password" placeholder="请输入登录密码" maxlength="10" minlength="6"
                show-password></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pwdDialog=false">取 消</el-button>
        <el-button type="primary" @click="editPassword">提交</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

import Edit from "./Edit";
import Add from "./Add";
import ElderlyRel from "./ElderlyRel";

export default {
  name: "Page",
  components:{Add,Edit,ElderlyRel},

  //注册局部过滤器
  filters: {
    timefilters(val) {
      if (val == null || val == "") {
        return "";
      } else {
        let d = new Date(val);   //val 为表格内取到的后台时间
        let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
        let times=d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
        return times;
      }
    }
  },

  data(){
    return{
      tableLoading:false,

      loading:false,
      dialogFormVisible:false,

      showModalAdd:false,
      showModalEdit:false,
      showModalElderlyEdit:false,

      bankCard:'',
      businessCode:'',

      tableData:null,
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      th:0,

      name:'',
      status:-1,


      uploadUrl:this.$shopUrl+'ImportNurseAideIns/Import',
      uploadData:{
        staffCode:getStaffCode(),
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey)
      },
      batchFileList:[],
      batchDialog:false,
      batchDialogError:false,
      showModal:false,
      timer:0,


      pwdDialog: false,
      password: '',
      userCode:'',


    }
  },

  created(){
    this.getList();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{

    getPhone(row,index,column){
      let str = column.substring(0,3);
      if(str == "100"){
        return "";
      }
      return column;
    },
    toggleModalAdd:function(){
      this.$refs.myAdd.init();
      this.showModalAdd = !this.showModalAdd;
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },

    handleEdit(index, row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },


    handleElderlyEdit(index, row) {
      this.$refs.myElderlyRel.init(row.nurseAideCode);
      this.showModalElderlyEdit = !this.showModalElderlyEdit;
    },
    closeElderlyEdit:function(){
      this.showModalElderlyEdit = !this.showModalElderlyEdit;
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch) {
      if(isSearch)this.currentPage=1

      this.tableLoading=true
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"NurseAide/Page",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          status:-1,
          name:this.name,
        }
      }).then( (response)=> {
        this.tableLoading=false
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }
      }).catch(function (error) {
        this.tableLoading=false
        console.log(error);
      });
    },



    closeBatchDialog(){
      this.$refs.upload.clearFiles();
    },
    submitUpload(){
      this.showModal=true
      this.$refs.upload.submit();
      this.crontab();
    },
    uploadSuccess(response){
      if(response.error === 0){
        this.batchDialog=false
        this.uuid = response.data;
      }else if(response.error === 1){
        this.$message.error(response.data.message)
      }
    },
    crontab() {
      this.timer = setInterval(this.getSuccess, 1000 * 1);
    },
    inCrontab() {
      clearInterval(this.timer);
    },
    getSuccess() {
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "ImportNurseAideIns/IsSuccess",
        data: {
          uuid: this.uuid
        }
      }).then((response) => {
        if (response.data.error === 0) {
          this.showModal=true
          this.isSuccess = response.data.data;
          if (this.isSuccess === "0") {
            this.showModal=true
          }
          if (this.isSuccess === "1") {
            this.$message({type: 'success', message: '导入成功'});
            this.showModal=false
            this.getList();
            this.inCrontab();
          }
          if (this.isSuccess === "2") {
            this.$message({type: 'error', message: '导入失败'});
            this.inCrontab();
            this.showModal=false
          }
          if (this.isSuccess !== "1" && this.isSuccess !== "2" && this.isSuccess !== "0") {
            if(this.isSuccess.length>10){
              this.batchDialogError=true
              this.errorData=this.isSuccess.split('<br>')
            }else{
              this.$message.error({type: 'success', message: this.isSuccess});
            }
            this.inCrontab();
            this.showModal=false
          }

        } else if (response.data.error === 1) {
          this.$message.error(response.data.message)
        } else if (response.data.error === 2) {
          this.$message({type: 'success', message: '导入失败'});
          this.inCrontab();
          this.showModal=false
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    getTemplate(){
      this.$axios.get(this.$shopUrl+'ImportNurseAideIns/Template',{
        responseType: 'blob',
        params:{
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then((response) => {
        let fileName = '护工导入模板.xlsx';
        let blob = new Blob([response.data]);
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          let elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
        }
      })
    },
    clearAll(){
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delete_do()
      }).catch(e=>e)
    },
    delete_do(){

      this.showModal = true;
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "NurseAide/InsDelete",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then((response) => {
        this.showModal=false;
        if (response.data.error == 0) {
          this.getList();
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        this.showModal=false;
        console.log(error);
      });
    },


    handlePassword(index,row) {
      this.pwdDialog = true;
      this.userCode = row.userCode;
      this.password = '';
    },
    editPassword() {

      if (this.password.length < 6) {
        this.$message('密码至少为六位')
        return;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl + 'User/EditPassword',
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          password: this.password,
          userCode:this.userCode,
        }
      }).then((response) => {
        console.log(response);
        if (response.data.error == 0) {
          this.$message('修改成功');
          this.pwdDialog = false
        } else if (response.data.error == 1) {
          this.$message(response.data.message);
        } else {
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },



  }
}
</script>

